export default __webpack_public_path__ + "static/media/progress-doing-ico.ec3738c2.svg";